import endpoint from 'utils/backend/endpoint.util';
import call from 'utils/functions/call.util';
import actionBe from 'utils/mw/actionBe.util';
import isNotFn from 'utils/predicates/function/isNotFn.util';

const actionEndpointBe = (atag, method, pattern, options) =>
  actionBe(atag, (inner) => {
    // TODO: add {METHOD: method, PATTERN: pattern} and fix tests
    const { ATAG, AT, ...extra } = inner ?? {};
    const merged = { ...options, AT, name: ATAG };

    if (isNotFn(options)) return endpoint(method, pattern, merged);

    const finalOptions = call('actionEndpointBe.options', options, merged, extra);
    return endpoint(method, pattern, finalOptions);
  });

export default actionEndpointBe;
